import { CategoryDetails } from "../types/homePageCategoryTypes";

export const homePageCategoryCreationInitialValues: CategoryDetails = {
  id: "",
  icon: "",
  name: "",
  nameEn: "",
  order: 1,
  active: true,
  showInServicesPage: true,
  accessRoles: [],
};
